import React from 'react';
import MenuItem from './MenuItem';

const CustomerService: React.FC = () => {
  return <MenuItem label="고객센터" />;
};

export default CustomerService;